<template>
  <div>
    <div class="contents">
      <BaseHeader title="バッチ一覧" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'Batch',
  components: {
  },
  created () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/system/BatchTop.vue